export default {
	install(Vue) {
        Vue.prototype.phrases = [
            '人生最困难的时候，也许正是转变的时候：改变固有的思想，人生就可能迎来转机。幸运，总是离努力的人更近一些。',
            '一声问候，一个愿望，一串祝福望你心中常有快乐涌现！',
            '生活不可能，像你想象的那么好，但也不会像你想象的那么糟，你的脆弱和坚强，往往都超乎自己的想象，悦纳自己，善待他人，热爱生命，努力生活！',
            '如果你不快乐，那就出去走走。世界这么大，风景很美机会很多，当阳光穿过树林，折射出绚烂的彩虹，你会惊叹生活的美好。',
            '人生最精彩的不是成功的那一瞬间，而是回头看，那段漆黑看似没有尽头、苦苦摸索的过程。',
            '一笑且把苦闷了，水迢迢，看岭上云长云消；闲来悠然倚斜桥，月皎皎，赏庭中花开花凋。愿你与清风共唱逍遥调，万丈红尘心不老，快乐无烦恼。',
            '每个人的人生里都会遇到一场措手不及的大雨，若你身陷雨中，愿有人为你撑伞；如果没有，也愿你有听雨的心情。',
            '努力做自己喜欢做的事和有趣的事情，让内心充满喜悦，让每一天都按照自己喜欢的方式度过。',
            '年轻，那么短暂，那么迷茫。如果你不能给自己一张耀眼的文凭一段荡气回肠的爱情，那么，你还可以给自己一个九成九会遭到嘲笑的梦想。因为，总有一天，它会让你闪闪发光。',
            '生活只有两种选择：重新出发，做自己生命的主角;抑或停留在原地，做别人的配角。',
            '越有故事的人越沉静简单，越肤浅单薄的人越浮躁不安。真正的强者，不是没有眼泪的人，而是含着眼泪依然奔跑的人。',
            '人生是一座可以采掘开拓的金矿，但总是因为人们的勤奋程度不同，给予人们的回报也不相同。',
            '做人做事，就俩字：心和眼。用眼睛去看现实社会的真善美，丑恶坏，用心感受现实生活，苦辣酸甜，人生凄凉，欢乐。',
            '人生的意义在于实现欲望。生存与发展的自我实现欲望。别名理想，奋斗目标，人生规划等。',
            '一个人的目标是从梦想开始。一个人的幸福从心态中被把握，一个人的成功就是在行动中实现的。因为只有行动就是滋养你成功的粮食。',
            '挫折是最好的最残酷的生存训练，关键是你有没有发现它的价值，借它之势成就自己。',
            '在偌大城市里，最容易失落孤单。其实我们缺少的不是热烈的拥抱，而是安安静静的陪伴。',
            '你在一生中，可以有所作为的时候只有一次。那就是现在，然而，许多人却在悔恨过去和担忧未来之中浪费了大好时光。',
            '接受突如其来的失去，珍惜不期而遇的惊喜。当情绪低落慵懒无力时，把情绪收到别人看不到的地方，一个人学会坚强。',
            '当你的才华还撑不起你的野心时，那你就应该静下心来学习。当你的经济还撑不起你的梦想时，那你就应该踏实的去做!',
            '击败不等于击倒，跌倒了，爬起来，想一想，为什么跌倒了，然后继续努力，把让自己跌倒的石头搬掉或绕过去，不就解决问题了吗?',
            '一念起，一念落，沉浮三界；一念红尘，一念阿鼻，坠入芜门；一念舍万物，一念得自然，方安于本我；念于众生困厄，方知悟道修缘；念于平生穷乏，当知明慧炼身；道可道，非常道，在于一念；名可名，非常名，也在于一念；一念善者，性可为万生之主；一念恶者，心当为万物之陋。',
            '认清这个世界，然后爱它，就这么一辈子，下一世你可能就不在这个世界了，有些烦恼，丢掉了，才有风轻云淡的机会。',
            '三想至千里，先积跬步；想成大海，先纳溪流。与其盯着别人不放，不如每天都回头看看，和昨天的自己相比，是否进步了一点点？愿你轻装上阵，踏实远行。'
        ]
    }}